import React, {Component, useContext} from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

import { CBadge } from '@coreui/react'
import {AllowedAccess} from "react-permission-role";
import { StateContext } from "../context/StateProvider";

export const SidebarNav = ({ items }) => {
  const location = useLocation()
  const { puedeAccederPanelPeticiones } = useContext(StateContext)
  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    )
  }

  const navItem = (item) => {
    const { component, name, badge, icon, ...rest } = item
    const Component = component
    const key = rest.to || name

    if (rest.to) {
      // DECISION: Panel de peticiones requiere verificación adicional de reponedor activo
      // Solo se muestra si es ADMIN o si es reponedor asignado activo
      if (name === 'Panel de peticiones' && !puedeAccederPanelPeticiones()) {
        return null;
      }

      return (
          <AllowedAccess roles={rest.roles} key={key}>
            <Component
                {...(rest.to && !rest.items && {
                  component: NavLink,
                })}
                {...rest}
            >
              {navLink(name, icon, badge)}
            </Component>
          </AllowedAccess>
      )
    } else {
      return (
          <Component key={key}>
            {name}
          </Component>
      )
    }
  }

  const navGroup = (item) => {
    const { component, name, icon, to, ...rest } = item
    const Component = component
    const key = to || name

    return (
        <AllowedAccess roles={rest.roles} key={key}>
          <Component
              idx={key}
              toggler={navLink(name, icon)}
              visible={location.pathname.startsWith(to)}
              {...rest}
          >
            {item.items?.map((child) =>
                child.items ? navGroup(child) : navItem(child)
            )}
          </Component>
        </AllowedAccess>
    )
  }

  return (
    <React.Fragment>
      {items &&
          items.map((item) =>
              item.items ? navGroup(item) : navItem(item)
          )}
    </React.Fragment>
  )
}

SidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}
